import { values, indexBy, prop } from 'ramda';
import moment from 'moment';

import { getProductions } from '../api';
import logger from '../utils/logger';

export const PRODUCTIONS_LOAD_ACTION = 'PRODUCTIONS_LOAD_ACTION';
export const PRODUCTIONS_RECEIVE_ACTION = 'PRODUCTIONS_RECEIVE_ACTION';

function loadProductionsAction({ date }) {
  return { type: PRODUCTIONS_LOAD_ACTION, date };
}

function receiveProductionsAction({ date, data, errors }) {
  console.log('[receiveProductionsAction] Data:', data);
  console.log('[receiveProductionsAction] Errors:', errors);
  return { type: PRODUCTIONS_RECEIVE_ACTION, date, data, errors };
}

const initialState = {};
function productionsReducer(state = initialState, action) {
  const { type } = action;
  switch (type) {
    case PRODUCTIONS_LOAD_ACTION:
      return {
        ...state,
        [action.date]: {
          loading: true,
          loaded: false,
          errors: null,
          data: {},
        },
      };
    case PRODUCTIONS_RECEIVE_ACTION:
      return {
        ...state,
        [action.date]: {
          loading: false,
          loaded: !action.errors,
          errors: action.errors || null,
          data:
            action.errors || !action.data || !action.data.productions
              ? {}
              : indexBy(prop('eicCode'), action.data.productions),
        },
      };
    default:
      return state;
  }
}

export function productionsLoadedSelector({ date: inputDate }, state) {
  const date = moment(inputDate).format('YYYY-MM-DD');
  return state.productions[date] && state.productions[date].loaded;
}

export function productionsErrorSelector({ date: inputDate }, state) {
  const date = moment(inputDate).format('YYYY-MM-DD');
  return state.productions[date] && state.productions[date].errors;
}

export function productionsSelector({ date: inputDate }, state) {
  const date = moment(inputDate).format('YYYY-MM-DD');
  return state.productions[date] && values(state.productions[date].data);
}

export function productionSelector({ date: inputDate, eicCode }, state) {
  const date = moment(inputDate).format('YYYY-MM-DD');
  console.log('productionSelector called:', { eicCode, date, inputDate });

  if (state.productions[date] && state.productions[date].data[eicCode]) {
    const data = state.productions[date].data[eicCode].values;
    console.log('productionSelector found data:', {
      eicCode,
      date,
      dataLength: data.length,
      firstValue: data[0]?.value,
    });

    const endOfDay = Array.from({
      length: 24 - data.length + 1,
    }).map(() => ({ value: null }));
    return data.map(d => ({ value: Math.max(d.value, 0) })).concat(endOfDay);
  }

  console.log('productionSelector no data found:', {
    eicCode,
    date,
    availableDates: Object.keys(state.productions || {}),
    hasDateData: !!state.productions[date],
    hasReactorData: !!(
      state.productions[date] && state.productions[date].data[eicCode]
    ),
  });
  return null;
}

export function loadAllProductions({ date: inputDate }) {
  const date = moment(inputDate).format('YYYY-MM-DD');
  console.log('loadAllProductions called for date:', date);

  return function dispatchLoadAllProductions(dispatch, getState) {
    const isLoaded = productionsLoadedSelector({ date }, getState());
    console.log('Production data already loaded for', date, ':', isLoaded);

    if (isLoaded) {
      console.log('Skipping production load for', date, '- already loaded');
      return Promise.resolve();
    }

    console.log('Loading production data for', date);
    dispatch(loadProductionsAction({ date }));
    return getProductions({ date })
      .then(data => {
        console.log(
          'Production data received for',
          date,
          ':',
          data?.productions ? Object.keys(data.productions).length : 0,
          'reactors',
        );
        dispatch(
          receiveProductionsAction({
            date,
            data,
          }),
        );
      })
      .catch(
        errors =>
          logger.error('Failed to load productions:', errors) ||
          dispatch(receiveProductionsAction({ date, errors })),
      );
  };
}

export default productionsReducer;
